import { configureStore } from '@reduxjs/toolkit';
import LoginReducer from './reducers/account_reducer';
import MenuReducer from './reducers/menu_reducer';
import CommonReducer from './reducers/common_reducer';
import PermissionReducer from './reducers/permission_reducer';
import CakeCategoryReducer from './reducers/cake_category_reducer';
import CakeSubCategoryReducer from './reducers/cake_sub_category_reducer';

export default configureStore({
  reducer: {
    account: LoginReducer,
    menu: MenuReducer,
    common: CommonReducer,
    permission: PermissionReducer,
    cake_categories: CakeCategoryReducer,
    cake_sub_categories: CakeSubCategoryReducer,
  },
});
